import EmailNewPasswordPopup from "./EmailNewPasswordPopup";

export default EmailNewPasswordPopup;